import React, {useEffect, useRef, useState} from "react";
import {Card} from "react-bootstrap";
import AdminService from "../../services/admin.service";
import FlatSelect from "../canopia/FlatSelect";
import CreatableSelect from "react-select/creatable";
import {useDispatch, useSelector} from "react-redux";
import {loadDates, selectDateState} from "../../reducer/dateSlice";
import {SecuredDownloadLink} from "../canopia/SecuredDownloadLink";
import {CheckSquareFill, Square} from "react-bootstrap-icons";
import ajaxloader from "../../images/ajax-loader.gif";
import Select from "react-select";
import {getLastWorkingDayOfPreviousQuarter} from "../canopia/CanopiaUtils";

export default function Import(props) {

    const dispatch = useDispatch();

    // const importTypes = ['Benchmark', 'Consensus'];
    // const importTypes = ['Benchmark'];
    // const importTypes = ['Global Custody', 'Benchmark', 'Real Estate', 'Fund'];
    const importTypes = [
        {key: 'fd', label: 'Fund'},
        {key: 'gc', label: 'Global Custody'},
        {key: 'cs', label: 'Consensus'},
        {key: 'bm', label: 'Benchmark'},
        {key: 're', label: 'Real Estate'},
        {key: 'in', label: 'Instruments'}
    ];

    const {dates, dateStatus} = useSelector(selectDateState);
    const [dateOptions, setDateOptions] = useState([]);
    const [sourceOptions, setSourceOptions] = useState(null);

    // Params
    const [date, setDate] = useState('');
    const [clientId, setClientId] = useState(-1);
    const [importType, setImportType] = useState(importTypes[0]);
    const [sourceOption, setSourceOption] = useState({value: 'external', label: 'external'});
    const [persist, setPersist] = useState(false);
    const [overwrite, setOverwrite] = useState(false);

    // Either file or file name
    const [files, setFiles] = useState(null);
    const inputFiles = useRef(null);

    const [loading, setLoading] = useState(false);
    const [sourceStatus, setSourceStatus] = useState('idle');

    // Response
    const [messages, setMessages] = useState(null);
    const [errorName, setErrorName] = useState(null);
    const [errors, setErrors] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    // Load all the clients to populate the dropdown (done only once)
    useEffect(() => {
        if (dateStatus === "idle") {
            dispatch(loadDates());
        }
    }, [dateStatus, dispatch]);

    useEffect(() => {
        if (sourceStatus === 'idle') {
            setSourceStatus('pending');
            AdminService.loadSources()
                .then(response => {
                    let optionsTmp = [];

                    response.data.data.forEach(source => {
                        const id = source.label;
                        const type = source.sourceType;
                        const option = {value: id, label: id + ' (' + type + ')'};
                        optionsTmp.push(option);
                    });

                    setSourceOptions(optionsTmp);
                    setSourceStatus('success');
                }, error => {
                    setSourceStatus('error');
                });
        }
    }, [sourceStatus]);

    useEffect(() => {
        let optionsTmp = [];

        dates.forEach(date => {
            const option = {value: date, label: date};
            optionsTmp.push(option);
        });

        setDateOptions(optionsTmp);
    }, [dates]);

    const onChangePersist = () => {
        setPersist(!persist);
    }
    const onChangeOverwrite = () => {
        setOverwrite(!overwrite);
    }

    const handleRun = (e) => {
        e.preventDefault();

        setLoading(true);
        setMessages(null);
        setErrorName(null);
        setErrors(null);
        setErrorMessage(null);

        switch (importType.key) {
            case 'gc':
                AdminService.importGC(files)
                    .then(
                        response => {
                            setMessages(response.data ? response.data.data : null);
                            setLoading(false);
                            setFiles(null);
                            if (inputFiles.current) {
                                inputFiles.current.value = "";
                                inputFiles.current.type = "file";
                            }
                        },
                        error => {
                            setLoading(false);
                            processError(error);
                        }
                    );
                break;
            case 'cs':
                AdminService.importConsensus(files, date.value)
                    .then(
                        response => {
                            setMessages(response.data ? response.data.data : null);
                            setLoading(false);
                        },
                        error => {
                            setLoading(false);
                            processError(error);
                        }
                    );
                break;
            case 'bm':
                AdminService.importBM(files, persist, overwrite)
                    .then(
                        response => {
                            setMessages(response.data ? response.data.data : null);
                            setLoading(false);
                        },
                        error => {
                            setLoading(false);
                            processError(error);
                        }
                    );
                break;
            case 're':
                AdminService.importRE(files, clientId, date.value)
                    .then(
                        response => {
                            setMessages(response.data ? response.data.data : null);
                            setLoading(false);
                        },
                        error => {
                            setLoading(false);
                            processError(error);
                        }
                    );
                break;
            case 'fd':
                AdminService.importFund(files, sourceOption.value)
                    .then(
                        response => {
                            setMessages(response.data ? response.data.data : null);
                            setLoading(false);
                            setFiles(null);
                            if (inputFiles.current) {
                                inputFiles.current.value = "";
                                inputFiles.current.type = "file";
                            }
                        },
                        error => {
                            setLoading(false);
                            processError(error);
                        }
                    );
                break;
            case 'in':
                AdminService.importInstruments()
                    .then(
                        response => {
                            setMessages(response.data ? response.data.data : null);
                            setLoading(false);
                        },
                        error => {
                            setLoading(false);
                            processError(error);
                        }
                    );
                break;
            default:
                console.log("error, unknown type " + importType);
        }

    }

    const processError = (error) => {
        let response = error.response;

        let errorName;
        let errors;
        let errorMessage;
        if (response &&
            response.data &&
            response.data.error &&
            response.data.message) {
            errorName = response.data.error;
            errors = response.data.errors;
            errorMessage = response.data.message;
        } else {
            errorName = 'Service unavailable';
            errorMessage = 'We apologize for the inconvenience, our team is working on solving the issue. Please try to come back in a few minutes.\nThank you for your patience.';
            errors = '';
            if (error.message) {
                console.log(error.message);
            }
        }

        setErrorName(errorName);
        setErrors(errors);
        setErrorMessage(errorMessage);
    }

    const handleDateChange = (date, action) => {

        let dateValue;
        switch (action.action) {
            case 'create-option':
                dateValue = date ? date.value.trim() : null;
                if (dateValue) {
                    let tmpOptions = [...dateOptions];
                    tmpOptions.push({value: dateValue, label: dateValue});
                    tmpOptions.sort((a, b) => a.value > b.value ? -1 : 1);
                    setDateOptions(tmpOptions);
                }
                break;
            default:
            //
        }

        setDate(date);
    }

    const onFileChange = (event) => {
        setFiles(event.target.files);
    }

    const onSourceChange = (source, action) => {
        setSourceOption(source);
    }

    let instrAnchorDate = getLastWorkingDayOfPreviousQuarter(new Date());

    let content = <Card className={'canopia-card'} style={{width: '75rem'}}>
        <Card.Body>
            <Card.Title className='canopia-card-title'>Data import</Card.Title>

            <form onSubmit={handleRun}>
                <div className="form-group">
                    <FlatSelect enums={importTypes} curValue={importType} curClass={'canopia-nav-link-active'}
                                otherClass={'canopia-nav-link'}
                                clickFunction={setImportType} clickParamFromEnum={true}/>
                </div>
                <br/>
                {importType.key === 'gc' && <>
                    <p>Please select a GC file to upload under Canopia_Review/$CLIENT_CODE$/DATE</p>
                    <p>NB: Existing data is deleted first</p>
                    <p>Template <SecuredDownloadLink method='template' type='gc'
                                                     fileName='DBSpec_$CLIENT_CODE$_yyyy-mm-dd.xlsx'/></p>
                    <div className="form-group">
                        <label>GC File</label>
                        <input type="file"
                               className={'form-control'}
                               aria-label="GC File"
                               onChange={onFileChange}
                               aria-describedby="basic-addon2"
                               ref={inputFiles}/>
                    </div>
                </>}
                {importType.key === 'cs' && <>
                    <p>Import a consensus and the compatible set of instruments to be used with (the instruments are retrieved automatically from ESGine).</p>
                    <p>NB: Existing data will be deleted first</p>
                    <p>
                        Select the files to import a new consensus from. The target consensus ID ($CONSENSUS_ID$)
                        will be extracted from the 2 required file names as follow:
                    </p>
                    <ul>
                        <li>Consensus: ESG_$CONSENSUS_ID$_***.csv</li>
                        <li>Other metrics: SBTi_ESG$CONSENSUS_ID$.csv</li>
                    </ul>
                    <label>Select the 2 files here</label>
                    <input type="file"
                           className={'form-control'}
                           aria-label="CS File"
                           onChange={onFileChange}
                           aria-describedby="basic-addon2"
                           ref={inputFiles}
                           multiple
                    />
                </>}
                {importType.key === 'bm' && <>
                    <p>Please select the BM files</p>
                    <p>NB: the date in the filename is ignored, only the composition date inside the file matters </p>
                    <label>Files</label>
                    <input type="file"
                           className={'form-control'}
                           aria-label="BM File"
                           onChange={onFileChange}
                           aria-describedby="basic-addon2"
                           ref={inputFiles}
                           multiple
                    />

                    <label style={{marginTop: '1rem'}}>Persist compositions</label>
                    <span onClick={onChangePersist} style={{marginLeft: "1rem"}}>
                            {persist ? <CheckSquareFill color={'#adad2f'} size={'1.4em'}/> :
                                <Square color={'#adad2f'} size={'1.4em'}/>}
                    </span>
                    <div>NB: it is recommended to leave it unchecked to see the comparison between the previous and
                        the new compositions, then check it if you want to persist the new compositions
                    </div>

                    <label style={{marginTop: '1rem'}}>Overwrite existing compositions</label>
                    <span onClick={onChangeOverwrite} style={{marginLeft: "1rem"}}>
                            {overwrite ? <CheckSquareFill color={'#adad2f'} size={'1.4em'}/> :
                                <Square color={'#adad2f'} size={'1.4em'}/>}
                    </span>
                    <div>NB: it is recommended to leave it unchecked to see if any compositions are already stored, then
                        check it if overwriting is required
                    </div>
                </>}
                {importType.key === 're' && <>
                    <p>Please a Real Estate file to upload (.xlsx)</p>
                    <p>NB: Existing data is deleted first</p>
                    <div className="form-group">
                        <label>File</label>
                        <input type="file"
                               className={'form-control'}
                               aria-label="Real Estate File"
                               onChange={onFileChange}
                               aria-describedby="basic-addon2"
                               ref={inputFiles}/>
                    </div>
                </>}
                {importType.key === 'fd' && <>
                    <p>Please select fund file(s) to upload</p>
                    <div className="form-group">
                        <label>Fund Files</label>
                        <input type="file"
                               className={'form-control'}
                               aria-label="Fund Files"
                               onChange={onFileChange}
                               aria-describedby="basic-addon2"
                               ref={inputFiles}
                               multiple/>
                    </div>
                    <br/>
                    <div className="form-group">
                        <label>Source</label>
                        {sourceStatus === 'success' ?
                            <Select options={sourceOptions}
                                    placeholder={'Select a source'}
                                    name={'source-select'}
                                    value={sourceOption}
                                    closeMenuOnSelect={true}
                                    onChange={onSourceChange}/>
                            : <div><img alt="loading" src={ajaxloader}/></div>}
                    </div>
                </>}
                {importType.key === 'in' && <>
                    <p>Import the latest version of the instruments from ESGine in Canopia database.</p>
                    <p>The Canopia instrument database is incremental and therefore works with a diff-based approach with an anchor date, i.e. the last end of quarter.</p>
                    <p>Target date: <b>{instrAnchorDate.getFullYear()}-{("0" + (instrAnchorDate.getMonth() + 1)).slice(-2)}-{instrAnchorDate.getDate()}</b></p>
                    <p>NB: Existing data for the current target date is rolled back first</p>
                </>}

                {['re'].includes(importType.key) && <>
                    <br/>
                    <div className="form-group">
                        <label>Client ID</label>
                        <input value={clientId}
                               placeholder="e.g. 123"
                               className={'form-control'}
                               style={{width: "180px"}}
                               aria-label="Consensus ID"
                               onChange={(event) => setClientId(event.target.value)}
                               aria-describedby="basic-addon2"/>
                    </div>
                </>}

                {['re', 'cs'].includes(importType.key) && <>
                    <br/>
                    <div className="form-group">
                        <label>Date (yyyy-MM-dd)</label>
                        <CreatableSelect options={dateOptions}
                                         placeholder={'yyyy-MM-dd'}
                                         name={'date-select'} //
                                         value={date}
                                         closeMenuOnSelect={true}
                                         onChange={handleDateChange}/>
                    </div>
                </>}

                <div className="form-group" style={{marginTop: '1rem'}}>
                    <button className="btn btn-primary btn-block" disabled={loading}>
                        {loading && (
                            <span className="spinner-border spinner-border-sm" style={{marginRight: '5px'}}/>
                        )}
                        <span>Import</span>
                    </button>
                </div>
                <br/>

                {loading &&
                    <p style={{color: "red"}}>Please do not refresh the page, the process may take some time</p>}

                {messages && (
                    <div className="form-group">
                        <br/>
                        <h5>Results:</h5>
                        <div className={"alert import_log"}>
                            {messages.map(message => {
                                return <div className={"import_log_" + message.key}>{message.value}</div>
                            })}
                        </div>
                    </div>
                )}

                {errorName && (
                    <div className="form-group">
                        <div className={"alert alert-danger"} role="alert">
                            <h3 className='canopia'>{errorName}</h3>
                            {errorMessage}
                            {errors && errors.map(error => {
                                return <li key={error.field}>{error.defaultMessage && error.defaultMessage}</li>
                            })
                            }
                        </div>
                    </div>
                )}
            </form>
        </Card.Body>
    </Card>;

    return (
        <div className="main-content">
            {content}
        </div>
    );
}
